import React, { useState } from "react";
import List from "../courseList";
import Filter from "../courseFilter";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import PATHS from "../../../../constants/paths";
import { BreadCrumb } from "@de-prado-dev/react-component-library";
import { useNavigate } from "react-router-dom";
import { USER_PERMISSIONS } from "../../../security/permissions/rolesPermission";
import { Can } from "../../../security/permissions/Can";
import {
  Header,
  HeaderTop,
  HeaderIcon,
  HeaderContent,
  Title,
  Subtitle,
  NewSessionButton,
  PageContainer,
} from "./../courseList/courseList.styled";

const queryClient = new QueryClient();

const CourseFilterListContainer = (props) => {
  const { t } = useTranslation();
  const [filters, setFilters] = useState(undefined);
  const navigate = useNavigate();
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.course.title") },
  ];

  const handlerCleanFilter = async (resetForm) => {
    resetForm();
    setFilters(undefined);
  };

  const goToForm = async () => {
    navigate(PATHS.CREATE_COURSE);
  };

  const handlerOnSubmitFilter = (values) => {
    let newFilter = {};
    const valuesFilters = Object.entries(values);
    valuesFilters.forEach((value) => {
      if (value[1] !== undefined && value[1].toString().length > 0) {
        newFilter[value[0]] = value[1];
      }
    });

    setFilters(newFilter);
  };

  return (
    <>
      <PageContainer>
        <Header>
          <HeaderTop>
            <HeaderIcon>
              <i className="fas fa-graduation-cap"></i>
            </HeaderIcon>
            <HeaderContent>
              <Title>{t("forms.course.title")}</Title>
              <Subtitle>{t("forms.course.subtitle")}</Subtitle>
            </HeaderContent>
            <Can do={USER_PERMISSIONS.CREATE_COURSE}>
              <NewSessionButton onClick={goToForm}>
                <i className="fas fa-plus"></i>
                {t("forms.course.buttons.new")}
              </NewSessionButton>
            </Can>
          </HeaderTop>
          {/* <BreadCrumb items={breads} /> */}

          <Filter
            onSubmit={handlerOnSubmitFilter}
            onClean={handlerCleanFilter}
          />
        </Header>
        {/* <div className="row justify-content-center mt-5">
          <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
            <h3 className="title">{t("forms.course.title")}</h3>
          </div>
        </div> 
        <BreadCrumb items={breads} />
        <div className="row justify-content-center">
          <div className="col-12 col-md-11">
            <Filter
              onSubmit={handlerOnSubmitFilter}
              onClean={handlerCleanFilter}
            />
          </div>
        </div>*/}
        <Header>
          {/* <div className="row justify-content-center">
            <div className="col-12 col-md-11"> */}
          <QueryClientProvider client={queryClient}>
            <List className="marg-top-1rem" filters={filters} />
          </QueryClientProvider>
          {/* </div>
          </div> */}
        </Header>
        {/* <div className="row justify-content-center mt-4 mb-5">
          <div className="col-12 col-md-11 d-flex justify-content-center">
            <Can do={USER_PERMISSIONS.CREATE_COURSE}>
              <button
                className="btn btn-secondary btn-md"
                onClick={() => goToForm()}
              >
                {t("forms.course.buttons.new")}
              </button>
            </Can>
          </div>
        </div> */}
      </PageContainer>
    </>
  );
};

CourseFilterListContainer.propTypes = {};

export default CourseFilterListContainer;
